import React from "react";
import { useActiveCartItem } from "../CartItemModalRootScreen/hooks";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { CartItemRootParmList } from "../../../../types";
import { View } from "react-native-ui-lib";
import {
  Button,
  Page,
  TextButton,
  TextField,
} from "@towersystems/roam-common-native";

interface EditCartItemNoteScreenProps
  extends NativeStackScreenProps<
    CartItemRootParmList,
    "EditCartItemNoteScreen"
  > {}

export const EditCartItemNoteScreen = ({
  navigation,
}: EditCartItemNoteScreenProps) => {
  const { item } = useActiveCartItem();

  const [value, setValue] = React.useState(item.customerNote || "");
  const shouldFocus = useHasTransitionEnded(navigation);
  const title = item.customerNote ? "Edit Customer Note" : "Add Customer Note";

  const handleOnSave = React.useCallback(() => {
    return item
      .updateCustomerNote(value)
      .then(() => navigation.goBack())
      .catch((err) => console.log(err));
  }, [item, value]);

  React.useEffect(() => {
    navigation.setOptions({
      headerRight: () => (
        <Button
          label="Save Note"
          isAction
          size="compact"
          onPress={() => handleOnSave()}
        ></Button>
      ),
    });
  }, [title, handleOnSave]);

  const footer = item.customerNote ? (
    <View>
      <Button
        onPress={() => {
          item.updateCustomerNote("");
          navigation.goBack();
        }}
        label="Remove Note"
        isDestructive
      ></Button>
    </View>
  ) : null;

  return (
    <Page scrollable={false} footer={footer}>
      <View style={{ height: "100%" }} flex>
        <TextField
          textarea
          placeholder="Leave a customer note for line item..."
          value={value}
          onChangeText={(v) => setValue(v)}
          autoFocus={shouldFocus}
        />
      </View>
    </Page>
  );
};
